/**
 * Navigation Definitions
 * 
 * Pure data definitions for navigation menus.
 * No rendering logic - just menu structure and metadata.
 */

import { ROUTES } from './routes';

export type NavRole = 'viewer' | 'editor' | 'admin' | 'owner';

export interface NavItem {
  id: string;
  label: string;
  icon: string; // Icon name only - renderer decides how to display
  path: string;
  requiredRole?: NavRole;
  badge?: string; // Optional badge text
  children?: NavItem[];
}

/**
 * Main navigation menu structure
 * Per CANON.md Section 8.2
 */
export const MAIN_NAV: readonly NavItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'home',
    path: ROUTES.DASHBOARD,
  },
  {
    id: 'library',
    label: 'Library',
    icon: 'book',
    path: ROUTES.LIBRARY,
  },
  {
    id: 'projects',
    label: 'Projects',
    icon: 'folder',
    path: ROUTES.PROJECTS,
  },
  {
    id: 'exports',
    label: 'Exports',
    icon: 'file-down',
    path: ROUTES.EXPORTS,
  },
  {
    id: 'admin',
    label: 'Admin',
    icon: 'shield',
    path: ROUTES.ADMIN,
    requiredRole: 'admin',
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'settings',
    path: ROUTES.SETTINGS,
  },
  {
    id: 'billing',
    label: 'Billing',
    icon: 'credit-card',
    path: ROUTES.BILLING,
    requiredRole: 'owner',
  },
] as const;
